import React from 'react';
import text from './../assets/texts'
import SecondHead from './../components/SecondHead'

const Confid = (props) => {
    return (
        <>
        <SecondHead lang = {props.lang} link = {props.link}/>

        <div className="container">
             <div id="confid" className="row ">
                <div className="col bd-test ">     
                    <div style = {{width: "100%", height: "90%"}}>{text(props.lang)}</div>
                </div>
            </div>
        </div>
        </>
        
    );
};


export default Confid;
